import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const RemoteTypeWrapper = styled.article`
  /* width: 100%; */

  .ant-checkbox-wrapper {
    background-color: white;
    border: 1px solid #a2b4f2 !important;
    padding: 1rem 2rem;
    padding: 15px 15px;
  }
  // create media queries for movile device
  @media (max-width: 768px) {
    .ant-checkbox-group {
      display: grid !important;
      grid-template-columns: auto;
      grid-gap: 15px;
    }
  }

  .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    background: #0d2160 !important;
    border-color: #0d2160 !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #0d2160 !important;
    border-color: #0d2160 !important;
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #0d2160 !important;
  }

  .ant-radio-inner::after {
    border-color: #0d2160 !important;
  }

  span {
    text-transform: none !important;
  }
`
